import moment from 'moment'

const humanReadableDateDiff = (startDate: Date, endDate: Date) => {
  // All these actions so moment returns more than 26 days in human readable format
  // instead of the months
  const pastThreshold = moment.relativeTimeThreshold('d') as number
  moment.relativeTimeThreshold('d', 1000)
  const humanString = moment
    .duration(moment(startDate).diff(moment(endDate), 'day'), 'day')
    .humanize()
  moment.relativeTimeThreshold('d', pastThreshold)

  return humanString
}

export default humanReadableDateDiff
